module.exports = __webpack_public_path__ + "img/research-intro.b23d433b.png";